import React, { Component } from "react"
import { bindActionCreators } from "redux"
import { connect } from "react-redux"
import _ from "lodash"
import Title from "../general/title"
import times from "helpers/times"
import clone from "clone"
import moment from "moment"
import Switch from "react-switch"
import numeral from "numeral"
import colorArray from "helpers/colorArray"
import helpers from "helpers/helpers"
import settings from "settings"
import { Bar, Line } from "react-chartjs-2"
import ImageExport from "components/ImageExport"
import FullTable from "components/FullTable"
import FloorplanAnalysis from "widgets/floorplanClosingAnalysis"

class BuilderSalesSummary extends Component {
	//! Notes - sans means without the section
	constructor(props) {
		super(props)
		this.state = {
			filters: {},
			times: times(),
			sorted: [],
			sortedSans: [],
			filtered: [],
			filteredSans: [],
			closed: true, // toggle for showing sales vs closings - set to true at first as it will flip to false on load.
			closedSans: true, // sans meaning without section
			showing: "",
			showingSans: "",
			finalGross: {
				number: 0,
				sqft: 0,
				price: 0,
				hasTakedownPrice: 0,
				lot_price: 0,
			},
			model: {
				avg_price: 0,
				net: 0,
				avg_month: 0,
				avg_sqft: 0,
				avg_ppsqft: 0,
				total_price: 0,
				total_sqft: 0,
				total_lot_price: 0,
				gross: 0,
				hasTakedownPrice: 0,
				busts: 0,
				percentLot: 0,
			},
			data: [],
			dataSans: [],
			homeSalesColumns: [
				{
					Header: "Year",
					accessor: "year",
				},
				{
					Header: "Builder",
					accessor: "builder",
					filterMethod: (f, r) => helpers.tableText(f, r, "builder"),
				},
				{
					Header: "Lot Type",
					accessor: "lot_type",
				},
				{
					Header: "Net Contracts",
					accessor: "net",
					Footer: (props) => {
						let total = 0
						_.forEach(props.data, (v) => {
							total += v.net
						})
						if (typeof total == "number") {
							return total.toLocaleString()
						}
						return total
					},
				},
			],
			summaryColumns: [
				{
					Header: "Builder",
					accessor: "builder",
					filterMethod: (f, r) => helpers.tableText(f, r, "builder"),
				},
				{
					Header: "Lot Type",
					accessor: "lot_type",
					filterMethod: (f, r) => helpers.tableText(f, r, "lot_type"),
				},
				{
					Header: "Gross",
					accessor: "gross",
					filterMethod: (f, r) => helpers.tableText(f, r, "gross"),
					Footer: (props) => helpers.tableTotals(props, "gross", "0,0"),
				},
				{
					Header: "Cancels",
					accessor: "cancels",
					filterMethod: (f, r) => helpers.tableText(f, r, "cancels"),
					Footer: (props) => helpers.tableTotals(props, "cancels", "0,0"),
				},
				{
					Header: "Net",
					accessor: "net",
					filterMethod: (f, r) => helpers.tableText(f, r, "net"),
					Footer: (props) => helpers.tableTotals(props, "net", "0,0"),
				},
				{
					Header: "Starts",
					accessor: "starts",
					filterMethod: (f, r) => helpers.tableText(f, r, "starts"),
					Footer: (props) => helpers.tableTotals(props, "starts", "0,0"),
				},
				{
					Header: "Closings",
					accessor: "closings",
					filterMethod: (f, r) => helpers.tableText(f, r, "closings"),
					Footer: (props) => helpers.tableTotals(props, "closings", "0,0"),
				},
				{
					Header: "Net Realtor",
					accessor: "net_realtor",
					filterMethod: (f, r) => helpers.tableText(f, r, "net_realtor"),
				},
				{
					Header: "Net Builder",
					accessor: "net_builder",
					filterMethod: (f, r) => helpers.tableText(f, r, "net_builder"),
				},
			],
			builderSummaryColumns: [
				{
					Header: "Builder",
					accessor: "builder",
					filterMethod: (f, r) => helpers.tableText(f, r, "builder"),
				},
				{
					Header: "Traffic",
					accessor: "traffic",
					filterMethod: (f, r) => helpers.tableText(f, r, "traffic"),
					Footer: (props) => helpers.tableTotals(props, "traffic", "0,0"),
				},
				{
					Header: "Gross",
					accessor: "gross",
					filterMethod: (f, r) => helpers.tableText(f, r, "gross"),
					Footer: (props) => helpers.tableTotals(props, "gross", "0,0"),
				},
				{
					Header: "Cancels",
					accessor: "cancels",
					filterMethod: (f, r) => helpers.tableText(f, r, "cancels"),
					Footer: (props) => helpers.tableTotals(props, "cancels", "0,0"),
				},
				{
					Header: "Net",
					accessor: "net",
					filterMethod: (f, r) => helpers.tableText(f, r, "net"),
					Footer: (props) => helpers.tableTotals(props, "net", "0,0"),
				},
				{
					Header: "Starts",
					accessor: "starts",
					filterMethod: (f, r) => helpers.tableText(f, r, "starts"),
					Footer: (props) => helpers.tableTotals(props, "starts", "0,0"),
				},
				{
					Header: "Closings",
					accessor: "closings",
					filterMethod: (f, r) => helpers.tableText(f, r, "closings"),
					Footer: (props) => helpers.tableTotals(props, "closings", "0,0"),
				},
				{
					Header: "Net Realtor",
					accessor: "net_realtor",
					filterMethod: (f, r) => helpers.tableText(f, r, "net_realtor"),
				},
				{
					Header: "Net Builder",
					accessor: "net_builder",
					filterMethod: (f, r) => helpers.tableText(f, r, "net_builder"),
				},
			],
			homeSales: [],
		}
	}

	async componentDidMount() {
		await this.generateTable(true)
		this.generateTableSans(true)
	}

	async componentDidUpdate(prevProps) {
		if (prevProps !== this.props) {
			await this.generateTable(false)
			this.generateTableSans(false)
		}
	}

	generateTable = (flip) => {
		return new Promise((resolve, reject) => {
			let state = _.cloneDeep(this.state)
			let store = {}
			let finalGross = {
				sqft: 0,
				number: 0, // gross # of sales/closings
				price: 0,
				lot_price: 0,
				hasTakedownPrice: 0,
			}
			let start = moment.unix(this.props.currentDates.startStamp)
			let end = moment.unix(this.props.currentDates.endStamp)
			let daysBetween = end.diff(start, "days")
			let monthsBetween = end.diff(start, "months", true)
			if (flip) {
				state.showing = state.closed ? "Sales" : "Closings"
				state.closed = !state.closed
			}

			let set = state.closed ? this.props.payload.closings.current : this.props.payload.sales.current
			//
			_.forEach(set, (v) => {
				if (!v.builder || v.transfer_date) {
					return
				}
				let type = _.find(this.props.payload.public.lot_types, { id: v.lot_type })
				let builder = _.find(this.props.payload.public.builders, { id: v.builder })
				let section = _.find(this.props.payload.public.sections, { id: v.section_id })
				let neigh = _.find(this.props.payload.public.neighborhoods, { id: v.neighborhood })
				let property = _.find(this.props.payload.public.properties, { id: v.property })
				if (!type || !builder || !section || !neigh) {
					return
				}
				let path = `["${type.name}"]["${builder.name}"]["${neigh.name}"]["${section.name}"]`
				if (!_.has(store, path)) {
					let model = clone(this.state.model)
					_.setWith(store, path, model, Object)
					store[type.name][builder.name][neigh.name][section.name].property = property ? property.name : ""
				}
				store[type.name][builder.name][neigh.name][section.name].gross++
				v.takedown_price = parseFloat(v.takedown_price)
				if (!v.takedown_price) {
					v.takedown_price = 0
				}
				store[type.name][builder.name][neigh.name][section.name].net++
				store[type.name][builder.name][neigh.name][section.name].total_price += v.price
				store[type.name][builder.name][neigh.name][section.name].total_sqft += v.sqft
				store[type.name][builder.name][neigh.name][section.name].total_lot_price += v.takedown_price
				if (v.takedown_price > 0) {
					store[type.name][builder.name][neigh.name][section.name].hasTakedownPrice++
					finalGross.hasTakedownPrice++
				}
				finalGross.number++
				finalGross.sqft += v.sqft
				finalGross.price += v.price
				finalGross.lot_price += v.takedown_price
			})
			// Remove cancels
			_.forEach(this.props.payload.bustouts.current, (v) => {
				if (!v.builder || v.transfer_date) {
					return
				}
				let type = _.find(this.props.payload.public.lot_types, { id: v.lot_type })
				let builder = _.find(this.props.payload.public.builders, { id: v.builder })
				let section = _.find(this.props.payload.public.sections, { id: v.section_id })
				let neigh = _.find(this.props.payload.public.neighborhoods, { id: v.neighborhood })
				let property = _.find(this.props.payload.public.properties, { id: v.property })
				if (!type || !builder || !section || !neigh) {
					return
				}
				let path = `["${type.name}"]["${builder.name}"]["${neigh.name}"]["${section.name}"]`
				if (!_.has(store, path)) {
					let model = clone(this.state.model)
					_.setWith(store, path, model, Object)
					store[type.name][builder.name][neigh.name][section.name].property = property ? property.name : ""
				}
				store[type.name][builder.name][neigh.name][section.name].gross--
				v.takedown_price = parseFloat(v.takedown_price)
				if (!v.takedown_price) {
					v.takedown_price = 0
				}
				store[type.name][builder.name][neigh.name][section.name].net--
				store[type.name][builder.name][neigh.name][section.name].total_price -= v.price
				store[type.name][builder.name][neigh.name][section.name].total_sqft -= v.sqft
				store[type.name][builder.name][neigh.name][section.name].total_lot_price -= v.takedown_price
				finalGross.number--
				finalGross.sqft -= v.sqft
				finalGross.price -= v.price
				finalGross.lot_price -= v.takedown_price
			})
			//console.log(store)
			state.finalGross = finalGross
			// Add em up
			_.forEach(store, (builders, lotType) => {
				_.forEach(builders, (v, builderName) => {
					_.forEach(v, (neighs, neigh) => {
						_.forEach(neighs, (sections, section) => {
							if (sections.total_price && sections.net) {
								sections.avg_price = Math.round(sections.total_price / sections.net)
							}
							if (sections.total_sqft && sections.net) {
								sections.avg_sqft = Math.round(sections.total_sqft / sections.net)
							}
							if (sections.avg_price && sections.avg_sqft) {
								sections.avg_ppsqft =
									sections.avg_price && sections.avg_sqft
										? Math.round(sections.avg_price / sections.avg_sqft)
										: 0
							}
							if (sections.total_lot_price && sections.hasTakedownPrice) {
								sections.avg_lot_price = Math.round(
									sections.total_lot_price / sections.hasTakedownPrice
								)
							}
							if (sections.net && monthsBetween) {
								sections.avg_month = sections.net / monthsBetween
							}
							if (sections.avg_lot_price && sections.avg_price) {
								sections.percentLot = (sections.avg_lot_price / sections.avg_price) * 100
							}
							//console.log(sections)
						})
					})
				})
			})
			//
			let data = []

			_.forEach(store, (builder, lotType) => {
				_.forEach(builder, (v, builderName) => {
					_.forEach(v, (neighs, neigh) => {
						_.forEach(neighs, (sections, section) => {
							//let property = _.find(this.props.payload.public.properties, {id: })
							let f = {
								"Lot Type": lotType,
								Community: sections.property,
								Builder: builderName,
								Neighborhood: neigh,
								Section: section,
								//"Gross Sales": sections.gross,
								"Net Sales": sections.net,
								"Avg. Home Sales Price": sections.avg_price || 0,
								"Avg. Per Month": sections.avg_month || 0,
								"Avg. Sq.Ft.": sections.avg_sqft || 0,
								"Avg. Price Per Sq.Ft.": sections.avg_ppsqft || 0,
								"Avg. Lot Price": sections.avg_lot_price || 0,
								"Percent Lot Price / Home Price": sections.percentLot || 0,
								hasTakedowns: sections.hasTakedownPrice,
								totalPrice: sections.total_price,
								finalGross,
							}
							data.push(f)
						})
					})
				})
			})
			//console.log(data)
			state.data = data
			this.setState(state, () => {
				resolve()
			})
		})
	}

	generateTableSans = (flip) => {
		//? This is generating net data
		let state = _.cloneDeep(this.state)
		let store = {}
		let finalGross = {
			sqft: 0,
			number: 0, // gross # of sales/closings
			price: 0,
			lot_price: 0,
			hasTakedownPrice: 0,
		}
		let start = moment.unix(this.props.currentDates.startStamp)
		let end = moment.unix(this.props.currentDates.endStamp)
		let daysBetween = end.diff(start, "days")
		let monthsBetween = end.diff(start, "months", true)
		if (flip) {
			state.showingSans = state.closedSans ? "Sales" : "Closings"
			state.closedSans = !state.closedSans
		}

		let set = state.closedSans ? this.props.payload.closings.current : this.props.payload.sales.current
		_.forEach(set, (v) => {
			if (!v.builder || v.transfer_date) {
				return
			}
			let type = _.find(this.props.payload.public.lot_types, { id: v.lot_type })
			let builder = _.find(this.props.payload.public.builders, { id: v.builder })
			let property = _.find(this.props.payload.public.properties, { id: v.property })
			if (!type || !builder || !property) {
				return
			}
			let path = `["${type.name}"]["${builder.name}"]["${property.name}"]`
			if (!_.has(store, path)) {
				let model = clone(this.state.model)
				model.builder = v.builder
				model.lot_type = v.lot_type
				_.setWith(store, path, model, Object)
			}
			store[type.name][builder.name][property.name].gross++
			if (!v.takedown_price) {
				v.takedown_price = 0
			}
			store[type.name][builder.name][property.name].net++
			store[type.name][builder.name][property.name].total_price += v.price
			store[type.name][builder.name][property.name].total_sqft += v.sqft
			store[type.name][builder.name][property.name].total_lot_price += v.takedown_price
			if (v.takedown_price > 0) {
				store[type.name][builder.name][property.name].hasTakedownPrice++
				finalGross.hasTakedownPrice++
			}
			finalGross.number++
			finalGross.sqft += v.sqft
			finalGross.price += v.price
			finalGross.lot_price += v.takedown_price
		})
		// Remove cancels
		_.forEach(this.props.payload.bustouts.current, (v) => {
			if (!v.builder || v.transfer_date) {
				return
			}
			let type = _.find(this.props.payload.public.lot_types, { id: v.lot_type })
			let builder = _.find(this.props.payload.public.builders, { id: v.builder })
			let property = _.find(this.props.payload.public.properties, { id: v.property })
			if (!type || !builder || !property) {
				return
			}
			let path = `["${type.name}"]["${builder.name}"]["${property.name}"]`
			if (!_.has(store, path)) {
				let model = clone(this.state.model)
				model.builder = v.builder
				model.lot_type = v.lot_type
				_.setWith(store, path, model, Object)
			}
			//store[type.name][builder.name][property.name].gross--
			if (!v.takedown_price) {
				v.takedown_price = 0
			}
			store[type.name][builder.name][property.name].net--
			store[type.name][builder.name][property.name].total_price -= v.price
			store[type.name][builder.name][property.name].total_sqft -= v.sqft
			store[type.name][builder.name][property.name].total_lot_price -= v.takedown_price

			finalGross.number--
			finalGross.sqft -= v.sqft
			finalGross.price -= v.price
			finalGross.lot_price -= v.takedown_price
		})

		state.finalGross = finalGross
		// Add em up
		_.forEach(store, (builders, lotType) => {
			_.forEach(builders, (properties, builderName) => {
				_.forEach(properties, (v, propertyName) => {
					if (v.total_price && v.net) {
						v.avg_price = Math.round(v.total_price / v.net)
					}
					if (v.total_sqft && v.net) {
						v.avg_sqft = Math.round(v.total_sqft / v.net)
					}

					v.avg_ppsqft = v.avg_price && v.avg_sqft ? Math.round(v.avg_price / v.avg_sqft) : 0
					v.avg_lot_price =
						v.total_lot_price && v.hasTakedownPrice ? Math.round(v.total_lot_price / v.hasTakedownPrice) : 0
					v.avg_month = v.net && monthsBetween ? v.net / monthsBetween : 0
					v.percentLot = v.avg_lot_price && v.avg_price ? (v.avg_lot_price / v.avg_price) * 100 : 0
					// Determine the amount of traffic for this grouping
					let traffic = 0
					let indiv = _.filter(
						this.props.payload.traffic.current.entries,
						(r) => r.builder === v.builder && r.lot_type === v.lot_type
					)
					traffic = indiv.length
					_.forEach(this.props.payload.traffic.current.grouped.array, (r) => {
						if (r.builder === v.builder && r.lot_type === v.lot_type) {
							traffic += r.prospect_count + r.realtor_count
						}
					})
					v.traffic = traffic
					// Now leads
					let leads = 0
					_.forEach(this.props.payload.leads, (r) => {
						if (r.builder === v.builder && r.lot_type === v.lot_type) {
							leads++
						}
						//! This may double-count leads into multiple lot types since we can't tell which lot type they were inteerested in.  Better than not counting floor plans?
						if (r.builder === v.builder && r.floorplan) {
							leads++
						}
					})
					v.leads = leads
				})
			})
		})

		let data = []
		_.forEach(store, (builders, lotType) => {
			_.forEach(builders, (properties, builderName) => {
				_.forEach(properties, (v, propertyName) => {
					let f = {
						"Lot Type": lotType,
						Community: propertyName,
						Builder: builderName,
						"Gross Sales": v.gross,
						"Net Sales": v.net,
						"Avg. Home Sales Price": v.avg_price,
						"Avg. Per Month": v.avg_month,
						"Avg. Sq.Ft.": v.avg_sqft,
						"Avg. Price Per Sq.Ft.": v.avg_ppsqft,
						"Avg. Lot Price": v.avg_lot_price,
						"Percent Lot Price / Home Price": v.percentLot,
						"Leads To Traffic": v.traffic && v.leads ? v.leads / v.traffic : null,
						"Traffic To Sales": v.net && v.traffic ? v.net / v.traffic : null,
						Leads: v.leads,
						Traffic: v.traffic,
						hasTakedowns: v.hasTakedownPrice,
						totalPrice: v.total_price,
						finalGross,
					}
					data.push(f)
				})
			})
		})
		state.dataSans = data

		this.setState(state)
	}

	columns = () => {
		return [
			{
				Header: "Lot Type",
				accessor: "Lot Type",
				filterMethod: (f, r) => helpers.tableText(f, r, "Lot Type"),
			},
			{
				Header: "Builder",
				accessor: "Builder",
				filterMethod: (f, r) => helpers.tableText(f, r, "Builder"),
			},
			{
				Header: "Community",
				accessor: "Community",
				filterMethod: (f, r) => helpers.tableText(f, r, "Community"),
			},
			{
				Header: "Neighborhood",
				accessor: "Neighborhood",
				filterMethod: (f, r) => helpers.tableText(f, r, "Neighborhood"),
			},
			{
				Header: "Section",
				accessor: "Section",
				filterMethod: (f, r) => helpers.tableText(f, r, "Section"),
			},
			{
				Header: "Avg. Home Sales Price",
				accessor: "Avg. Home Sales Price",
				filterable: false,
				Cell: (v) => {
					if (v.value || v.value === 0) {
						return numeral(v.value).format("$0,0")
					}
					return numeral(v.original["Avg. Home Sales Price"]).format("$0,0")
				},
				/* Footer: (props) => {
					console.log(props)
					let set = this.state.closed ? this.props.payload.closings.current : this.props.payload.sales.current
					let total = 0
					let gross = 0
					_.forEach(set, (v) => {
						if (!v.builder || v.bustout_date || v.cancel_date || v.transfer_date) {
							return
						}
						// Type
						let type = _.find(this.state.filtered, { id: "Lot Type" })
						if (type) {
							if (!v.lotTypeName || !v.lotTypeName.toLowerCase().includes(type.value)) {
								return
							}
						}
						// Builder
						let builder = _.find(this.props.payload.public.builders, { id: v.builder })
						if (!builder) {
							return
						}
						let builderCheck = _.find(this.state.filtered, { id: "Builder" })
						if (builderCheck) {
							if (!builder.name.toLowerCase().includes(builderCheck.value)) {
								return
							}
						}
						// Community
						let com = _.find(this.props.payload.public.properties, { id: v.property })
						if (!com) {
							return
						}
						let comCheck = _.find(this.state.filtered, { id: "Community" })
						if (comCheck) {
							if (!com.name.toLowerCase().includes(comCheck.value)) {
								return
							}
						}
						// Neighborhood
						let neigh = _.find(this.state.filtered, { id: "Neighborhood" })
						if (neigh) {
							if (!v.neighborhoodName || !v.neighborhoodName.toLowerCase().includes(neigh.value)) {
								return
							}
						}
						// Section
						let section = _.find(this.state.filtered, { id: "Section" })
						if (section) {
							if (!v.sectionName || !v.sectionName.toLowerCase().includes(section.value)) {
								return
							}
						}
						total += v.price
						gross++
					})
					let ret = total / gross
					return numeral(ret).format("$0,0")
				}, */
			},
			{
				Header: "Avg. Lot Price",
				accessor: "Avg. Lot Price",
				filterable: false,
				Cell: (v) => {
					if (v.value || v.value === 0) {
						return numeral(v.value).format("$0,0")
					}
					return numeral(v.original["Avg. Lot Price"]).format("$0,0")
				},
				/* Footer: (props) => {
					let set = this.state.closed ? this.props.payload.closings.current : this.props.payload.sales.current
					let total = 0
					let gross = 0
					_.forEach(set, (v) => {
						if (!v.builder || v.bustout_date || v.cancel_date || v.transfer_date) {
							return
						}
						// Type
						let type = _.find(this.state.filtered, { id: "Lot Type" })
						if (type) {
							if (!v.lotTypeName || !v.lotTypeName.toLowerCase().includes(type.value)) {
								return
							}
						}
						// Builder
						let builder = _.find(this.props.payload.public.builders, { id: v.builder })
						if (!builder) {
							return
						}
						let builderCheck = _.find(this.state.filtered, { id: "Builder" })
						if (builderCheck) {
							if (!builder.name.toLowerCase().includes(builderCheck.value)) {
								return
							}
						}
						// Community
						let com = _.find(this.props.payload.public.properties, { id: v.property })
						if (!com) {
							return
						}
						let comCheck = _.find(this.state.filtered, { id: "Community" })
						if (comCheck) {
							if (!com.name.toLowerCase().includes(comCheck.value)) {
								return
							}
						}
						// Neighborhood
						let neigh = _.find(this.state.filtered, { id: "Neighborhood" })
						if (neigh) {
							if (!v.neighborhoodName || !v.neighborhoodName.toLowerCase().includes(neigh.value)) {
								return
							}
						}
						// Section
						let section = _.find(this.state.filtered, { id: "Section" })
						if (section) {
							if (!v.sectionName || !v.sectionName.toLowerCase().includes(section.value)) {
								return
							}
						}
						total += v.takedown_price
						if (v.takedown_price) {
							gross++
						}
					})
					let ret = total / gross
					return numeral(ret).format("$0,0")
				}, */
			},
			{
				Header: "Percent Lot Price / Home Price",
				accessor: "Percent Lot Price / Home Price",
				filterable: false,
				Cell: (v) => {
					if (v.value || v.value === 0) {
						return numeral(v.value / 100).format("0.00%")
					}
					let val = v.original["Percent Lot Price / Home Price"] / 100
					return numeral(val).format("0.00%")
				},
				/* Footer: (props) => {
					let set = this.state.closed ? this.props.payload.closings.current : this.props.payload.sales.current
					let salesPrice = 0
					let lotPrice = 0
					let sales = 0
					let hasTakedownPrice = 0
					_.forEach(set, (v) => {
						if (!v.builder || v.bustout_date || v.cancel_date || v.transfer_date) {
							return
						}
						// Type
						let type = _.find(this.state.filtered, { id: "Lot Type" })
						if (type) {
							if (!v.lotTypeName || !v.lotTypeName.toLowerCase().includes(type.value)) {
								return
							}
						}
						// Builder
						let builder = _.find(this.props.payload.public.builders, { id: v.builder })
						if (!builder) {
							return
						}
						let builderCheck = _.find(this.state.filtered, { id: "Builder" })
						if (builderCheck) {
							if (!builder.name.toLowerCase().includes(builderCheck.value)) {
								return
							}
						}
						// Community
						let com = _.find(this.props.payload.public.properties, { id: v.property })
						if (!com) {
							return
						}
						let comCheck = _.find(this.state.filtered, { id: "Community" })
						if (comCheck) {
							if (!com.name.toLowerCase().includes(comCheck.value)) {
								return
							}
						}
						// Neighborhood
						let neigh = _.find(this.state.filtered, { id: "Neighborhood" })
						if (neigh) {
							if (!v.neighborhoodName || !v.neighborhoodName.toLowerCase().includes(neigh.value)) {
								return
							}
						}
						// Section
						let section = _.find(this.state.filtered, { id: "Section" })
						if (section) {
							if (!v.sectionName || !v.sectionName.toLowerCase().includes(section.value)) {
								return
							}
						}
						salesPrice += v.price
						sales++
						if (v.takedown_price) {
							hasTakedownPrice++
							lotPrice += v.takedown_price
						}
					})
					let sp = salesPrice / sales
					let tdPrice = lotPrice / hasTakedownPrice
					let percent = numeral(tdPrice / sp).format("0.00%")
					return percent
				}, */
			},
			{
				Header: this.state.closed ? "Closings" : `Net Sales Contracts`,
				accessor: "Net Sales",
				filterable: false,
				Cell: (v) => {
					if (v.value || v.value === 0) {
						return numeral(v.value).format("0,0")
					}
					return v.original["Net Sales"]
				},
				/* Footer: (props) => {
					let total = 0
					_.forEach(props.data, (v) => {
						if (!v[["Net Sales"]]) {
							return
						}
						total += v[["Net Sales"]]
					})
					if (typeof total == "number") {
						return total.toLocaleString()
					}
					return total
				}, */
			},
			{
				Header: "Avg. Per Month",
				accessor: "Avg. Per Month",
				filterable: false,
				Cell: (v) => {
					if (v.value || v.value === 0) {
						return numeral(v.value).format("0,0")
					}
					return numeral(v.original["Avg. Per Month"]).format("0.00")
				},
				/* Footer: (props) => {
					let set = this.state.closed ? this.props.payload.closings.current : this.props.payload.sales.current
					let start = moment.unix(this.props.currentDates.startStamp)
					let end = moment.unix(this.props.currentDates.endStamp)
					let daysBetween = end.diff(start, "days")
					let monthsBetween = end.diff(start, "months", true)
					let gross = 0
					let busts = 0
					_.forEach(set, (v) => {
						if (!v.builder || v.bustout_date || v.cancel_date || v.transfer_date) {
							return
						}
						// Type
						let type = _.find(this.state.filtered, { id: "Lot Type" })
						if (type) {
							if (!v.lotTypeName || !v.lotTypeName.toLowerCase().includes(type.value)) {
								return
							}
						}
						// Builder
						let builder = _.find(this.props.payload.public.builders, { id: v.builder })
						if (!builder) {
							return
						}
						let builderCheck = _.find(this.state.filtered, { id: "Builder" })
						if (builderCheck) {
							if (!builder.name.toLowerCase().includes(builderCheck.value)) {
								return
							}
						}
						// Community
						let com = _.find(this.props.payload.public.properties, { id: v.property })
						if (!com) {
							return
						}
						let comCheck = _.find(this.state.filtered, { id: "Community" })
						if (comCheck) {
							if (!com.name.toLowerCase().includes(comCheck.value)) {
								return
							}
						}
						// Neighborhood
						let neigh = _.find(this.state.filtered, { id: "Neighborhood" })
						if (neigh) {
							if (!v.neighborhoodName || !v.neighborhoodName.toLowerCase().includes(neigh.value)) {
								return
							}
						}
						// Section
						let section = _.find(this.state.filtered, { id: "Section" })
						if (section) {
							if (!v.sectionName || !v.sectionName.toLowerCase().includes(section.value)) {
								return
							}
						}
						gross++
					})
					_.forEach(this.props.payload.bustouts.current, (v) => {
						// Type
						let type = _.find(this.state.filtered, { id: "Lot Type" })
						if (type) {
							if (!v.lotTypeName || !v.lotTypeName.toLowerCase().includes(type.value)) {
								return
							}
						}
						// Builder
						let builder = _.find(this.props.payload.public.builders, { id: v.builder })
						if (!builder) {
							return
						}
						let builderCheck = _.find(this.state.filtered, { id: "Builder" })
						if (builderCheck) {
							if (!builder.name.toLowerCase().includes(builderCheck.value)) {
								return
							}
						}
						// Community
						let com = _.find(this.props.payload.public.properties, { id: v.property })
						if (!com) {
							return
						}
						let comCheck = _.find(this.state.filtered, { id: "Community" })
						if (comCheck) {
							if (!com.name.toLowerCase().includes(comCheck.value)) {
								return
							}
						}
						// Neighborhood
						let neigh = _.find(this.state.filtered, { id: "Neighborhood" })
						if (neigh) {
							if (!v.neighborhoodName || !v.neighborhoodName.toLowerCase().includes(neigh.value)) {
								return
							}
						}
						// Section
						let section = _.find(this.state.filtered, { id: "Section" })
						if (section) {
							if (!v.sectionName || !v.sectionName.toLowerCase().includes(section.value)) {
								return
							}
						}
						busts++
					})
					let net = gross - busts
					let ret = net / monthsBetween
					return numeral(ret).format("0.00")
				}, */
			},
			{
				Header: "Avg. Sq.Ft.",
				accessor: "Avg. Sq.Ft.",
				filterable: false,
				Cell: (v) => {
					if (v.value || v.value === 0) {
						return numeral(v.value).format("0,0")
					}
					return numeral(v.original["Avg. Sq.Ft."]).format("0,0")
				},
				/* Footer: (props) => {
					let set = this.state.closed ? this.props.payload.closings.current : this.props.payload.sales.current
					let total = 0
					let gross = 0
					_.forEach(set, (v) => {
						if (!v.builder || v.bustout_date || v.cancel_date || v.transfer_date) {
							return
						}
						if (!v.sqft) {
							return
						}
						// Type
						let type = _.find(this.state.filtered, { id: "Lot Type" })
						if (type) {
							if (!v.lotTypeName || !v.lotTypeName.toLowerCase().includes(type.value)) {
								return
							}
						}
						// Builder
						let builder = _.find(this.props.payload.public.builders, { id: v.builder })
						if (!builder) {
							return
						}
						let builderCheck = _.find(this.state.filtered, { id: "Builder" })
						if (builderCheck) {
							if (!builder.name.toLowerCase().includes(builderCheck.value)) {
								return
							}
						}
						// Community
						let com = _.find(this.props.payload.public.properties, { id: v.property })
						if (!com) {
							return
						}
						let comCheck = _.find(this.state.filtered, { id: "Community" })
						if (comCheck) {
							if (!com.name.toLowerCase().includes(comCheck.value)) {
								return
							}
						}
						// Neighborhood
						let neigh = _.find(this.state.filtered, { id: "Neighborhood" })
						if (neigh) {
							if (!v.neighborhoodName || !v.neighborhoodName.toLowerCase().includes(neigh.value)) {
								return
							}
						}
						// Section
						let section = _.find(this.state.filtered, { id: "Section" })
						if (section) {
							if (!v.sectionName || !v.sectionName.toLowerCase().includes(section.value)) {
								return
							}
						}
						total += v.sqft
						gross++
					})
					let ret = total / gross
					return numeral(ret).format("0,0")
				}, */
			},
			{
				Header: "Avg. Price Per Sq.Ft.",
				accessor: "Avg. Price Per Sq.Ft.",
				filterable: false,
				Cell: (v) => {
					if (v.value || v.value === 0) {
						return numeral(v.value).format("$0,0")
					}
					return numeral(v.original["Avg. Price Per Sq.Ft."]).format("$0,0")
				},
				/* Footer: (props) => {
					let set = this.state.closed ? this.props.payload.closings.current : this.props.payload.sales.current
					let total = 0
					let sqft = 0
					_.forEach(set, (v) => {
						if (!v.builder || v.bustout_date || v.cancel_date || v.transfer_date) {
							return
						}
						// Type
						let type = _.find(this.state.filtered, { id: "Lot Type" })
						if (type) {
							if (!v.lotTypeName || !v.lotTypeName.toLowerCase().includes(type.value)) {
								return
							}
						}
						// Builder
						let builder = _.find(this.props.payload.public.builders, { id: v.builder })
						if (!builder) {
							return
						}
						let builderCheck = _.find(this.state.filtered, { id: "Builder" })
						if (builderCheck) {
							if (!builder.name.toLowerCase().includes(builderCheck.value)) {
								return
							}
						}
						// Community
						let com = _.find(this.props.payload.public.properties, { id: v.property })
						if (!com) {
							return
						}
						let comCheck = _.find(this.state.filtered, { id: "Community" })
						if (comCheck) {
							if (!com.name.toLowerCase().includes(comCheck.value)) {
								return
							}
						}
						// Neighborhood
						let neigh = _.find(this.state.filtered, { id: "Neighborhood" })
						if (neigh) {
							if (!v.neighborhoodName || !v.neighborhoodName.toLowerCase().includes(neigh.value)) {
								return
							}
						}
						// Section
						let section = _.find(this.state.filtered, { id: "Section" })
						if (section) {
							if (!v.sectionName || !v.sectionName.toLowerCase().includes(section.value)) {
								return
							}
						}
						total += v.price
						sqft += v.sqft
					})
					let ret = total / sqft
					return numeral(ret).format("$0,0")
				}, */
			},
		]
	}

	columnsSans = () => {
		return [
			{
				Header: "Lot Type",
				accessor: "Lot Type",
				filterMethod: (f, r) => helpers.tableText(f, r, "Lot Type"),
			},
			{
				Header: "Builder",
				accessor: "Builder",
				filterMethod: (f, r) => helpers.tableText(f, r, "Builder"),
			},
			{
				Header: "Community",
				accessor: "Community",
				filterMethod: (f, r) => helpers.tableText(f, r, "Community"),
			},
			{
				Header: "Avg. Home Sales Price",
				accessor: "Avg. Home Sales Price",
				filterable: false,
				Cell: (v) => {
					if (v.value || v.value === 0) {
						return numeral(v.value).format("$0,0")
					}
					return numeral(v.original["Avg. Home Sales Price"]).format("$0,0")
				},
			},
			{
				Header: "Avg. Lot Price",
				accessor: "Avg. Lot Price",
				filterable: false,
				Cell: (v) => {
					if (v.value || v.value === 0) {
						return numeral(v.value).format("$0,0")
					}
					return numeral(v.original["Avg. Lot Price"]).format("$0,0")
				},
			},
			{
				Header: "Percent Lot Price / Home Price",
				accessor: "Percent Lot Price / Home Price",
				filterable: false,
				Cell: (v) => {
					if (v.value || v.value === 0) {
						return numeral(v.value / 100).format("0.00%")
					}
					let val = v.original["Percent Lot Price / Home Price"] / 100
					return numeral(val).format("0.00%")
				},
			},
			{
				Header: this.state.closedSans ? "Closings" : `Net Sales Contracts`,
				accessor: "Net Sales",
				filterable: false,
				Cell: (v) => {
					if (v.value || v.value === 0) {
						return numeral(v.value).format("0,0")
					}
					return v.original["Net Sales"]
				},
			},
			{
				Header: `Leads`,
				accessor: "Leads",
				filterable: false,
				Cell: (v) => {
					if (v.value || v.value === 0) {
						return numeral(v.value).format("0,0")
					}
					return v.original["Leads"]
				},
			},
			{
				Header: `Traffic`,
				accessor: "Traffic",
				filterable: false,
				Cell: (v) => {
					if (v.value || v.value === 0) {
						return numeral(v.value).format("0,0")
					}
					return v.original["Traffic"]
				},
			},
			{
				Header: "Avg. Per Month",
				accessor: "Avg. Per Month",
				filterable: false,
				Cell: (v) => {
					if (v.value || v.value === 0) {
						return numeral(v.value).format("0.00")
					}
					return numeral(v.original["Avg. Per Month"]).format("0.00")
				},
			},
			{
				Header: "Leads To Traffic",
				accessor: "Leads To Traffic",
				filterable: false,
				Cell: (v) => {
					if (v.value === null) return null
					if (v.value || v.value === 0) {
						return numeral(v.value).format("0%")
					}
					return numeral(v.original["Leads To Traffic"]).format("0%")
				},
			},
			{
				Header: "Traffic To Sales",
				accessor: "Traffic To Sales",
				filterable: false,
				Cell: (v) => {
					if (v.value === null) return null
					if (v.value || v.value === 0) {
						return numeral(v.value).format("0%")
					}
					return numeral(v.original["Traffic To Sales"]).format("0%")
				},
			},
			{
				Header: "Avg. Sq.Ft.",
				accessor: "Avg. Sq.Ft.",
				filterable: false,
				Cell: (v) => {
					if (v.value || v.value === 0) {
						return numeral(v.value).format("0,0")
					}
					return numeral(v.original["Avg. Sq.Ft."]).format("0,0")
				},
			},
			{
				Header: "Avg. Price Per Sq.Ft.",
				accessor: "Avg. Price Per Sq.Ft.",
				filterable: false,
				Cell: (v) => {
					if (v.value || v.value === 0) {
						return numeral(v.value).format("$0,0")
					}
					return numeral(v.original["Avg. Price Per Sq.Ft."]).format("$0,0")
				},
			},
		]
	}

	buildHomeSalesChartData = () => {
		let store = {}
		let years = []
		// Get years based on selected date range
		_.forEach(this.props.payload.sales.current, (v) => {
			let year = moment.unix(v.sale_date).format("YYYY")
			years.push(year)
		})
		_.forEach(this.props.payload.bustouts.current, (v) => {
			let year = moment.unix(v.bustout_date).format("YYYY")
			years.push(year)
		})
		years = _.uniq(years)
		years = _.orderBy(years)

		_.forEach(this.props.payload.sales.current, (v) => {
			let year = moment.unix(v.sale_date).format("YYYY")
			let builder = _.find(this.props.payload.public.builders, { id: v.builder })
			let type = _.find(this.props.payload.public.lot_types, { id: v.lot_type })
			if (!builder || !type) {
				return
			}
			// Remove periods from names
			builder.name = builder.name.replace(/[^\w- ]+/g, "")
			// Need to ensure this combination is on every year
			_.forEach(years, (year) => {
				let path = `["${year}"].${type.name} - ${builder.name}`
				if (!_.has(store, path)) {
					_.setWith(store, path, { gross: 0, cancels: 0 }, Object)
				}
			})
			store[year][`${type.name} - ${builder.name}`].gross++
		})
		_.forEach(this.props.payload.bustouts.current, (v) => {
			let year = moment.unix(v.bustout_date).format("YYYY")
			let builder = _.find(this.props.payload.public.builders, { id: v.builder })
			let type = _.find(this.props.payload.public.lot_types, { id: v.lot_type })
			if (!builder || !type) {
				return
			}
			// Need to ensure this combination is on every year
			_.forEach(years, (year) => {
				let path = `["${year}"].${type.name} - ${builder.name}.cancels`
				if (!_.has(store, path)) {
					_.setWith(store, path, { gross: 0, cancels: 0 }, Object)
				}
			})
			store[year][`${type.name} - ${builder.name}`].cancels++
		})
		return store
	}

	buildHomeSalesData = () => {
		let store = {}
		let years = []
		// Get years based on selected date range
		_.forEach(this.props.payload.sales.current, (v) => {
			let year = moment.unix(v.sale_date).format("YYYY")
			years.push(year)
		})
		_.forEach(this.props.payload.bustouts.current, (v) => {
			let year = moment.unix(v.bustout_date).format("YYYY")
			years.push(year)
		})
		years = _.uniq(years)
		years = _.orderBy(years)

		_.forEach(this.props.payload.sales.current, (v) => {
			let year = moment.unix(v.sale_date).format("YYYY")
			let builder = _.find(this.props.payload.public.builders, { id: v.builder })
			let type = _.find(this.props.payload.public.lot_types, { id: v.lot_type })
			if (!builder || !type) {
				return
			}
			// Need to ensure this combination is on every year
			_.forEach(years, (year) => {
				let path = `["${year}"].["${type.name}"].["${builder.name}"]`
				if (!_.has(store, path)) {
					_.setWith(store, path, 0, Object)
				}
			})
			store[year][type.name][builder.name]++
		})
		_.forEach(this.props.payload.bustouts.current, (v) => {
			let year = moment.unix(v.bustout_date).format("YYYY")
			let builder = _.find(this.props.payload.public.builders, { id: v.builder })
			let type = _.find(this.props.payload.public.lot_types, { id: v.lot_type })
			if (!builder || !type) {
				return
			}
			// Need to ensure this combination is on every year
			_.forEach(years, (year) => {
				let path = `["${year}"].["${type.name}"].["${builder.name}"]`
				if (!_.has(store, path)) {
					_.setWith(store, path, 0, Object)
				}
			})
			store[year][type.name][builder.name]--
		})
		return { store, years }
	}

	homeSalesChart = () => {
		let data = this.buildHomeSalesChartData()
		//console.log(data)
		let store = []
		_.forEach(data, (yearRow, year) => {
			let yearArray = []
			_.forEach(yearRow, (values, lotType) => {
				yearArray.push({
					name: lotType,
					values,
				})
			})
			yearArray = _.sortBy(yearArray, "name")
			store.push({
				year,
				data: yearArray,
			})
		})
		let datasets = []
		let labels = store[0] ? _.map(store[0].data, (v) => v.name) : []
		_.forEach(store, (v) => {
			let gross = _.map(v.data, (r) => r.values.gross - r.values.cancels)
			datasets.push({
				label: `${v.year} Net Sales`,
				backgroundColor: "#74E0AD",
				stack: v.year,
				data: gross,
			})
			let cancels = _.map(v.data, (r) => r.values.cancels)
			datasets.push({
				label: `${v.year} Cancels`,
				backgroundColor: "#EE7783",
				stack: v.year,
				data: cancels,
			})
			/* let total = _.map(v.data, (r) => r.values.gross)
			datasets.push({
				label: `${v.year} Total`,
				backgroundColor: "transparent",
				stack: v.year,
				data: total,
				datalabels: {
					align: "start",
					anchor: "start",
					display: true,
				},
			}) */
		})
		let chartData = {
			labels,
			datasets,
		}
		// This was a work in progress to add totals above but needs more work.
		// See: https://github.com/chartjs/chartjs-plugin-datalabels/issues/16 - we break out by year, so utmost has two values (object) instead of just number
		/* const totalizer = {
			id: "totalizer",
			beforeUpdate: function (chart) {
				var totals = []
				var utmost = {}
				chart.data.datasets.forEach(function (dataset, datasetIndex) {
					if (chart.isDatasetVisible(datasetIndex)) {
						var stack = dataset.stack
						utmost[stack] = datasetIndex
						dataset.data.forEach(function (value, index) {
							if (totals[index] === undefined) {
								totals[index] = {}
							}
							totals[index][stack] = (totals[index][stack] || 0) + value
						})
					}
				})
				chart.$totalizer = {
					totals: totals,
					utmost: utmost,
				}
			},
		} */
		const opts = {
			legend: {
				display: false,
				position: "bottom",
			},
			scales: {
				yAxes: [
					{
						scaleLabel: {
							display: true,
							labelString: "Gross Sales",
						},
					},
				],
			},
			plugins: {
				//datalabels: { clamp: true, anchor: "end", align: "end", offset: 5 },
				/* datalabels: {
					//display: true,
					formatter: (value, ctx) => {
						console.log(ctx)
						const total = ctx.chart.$totalizer.totals[ctx.dataIndex]
						return total
					},
					display: function (ctx) {
						console.log(ctx)
						return ctx.datasetIndex === ctx.chart.$totalizer.utmost
					},
				}, */
			},
			/* animation: {
				onComplete: function () {
					var chartInstance = this.chart
					var ctx = chartInstance.ctx
					ctx.textAlign = "left"
					ctx.font = "9px Open Sans"
					ctx.fillStyle = "#fff"

					Chart.helpers.each(
						this.data.datasets.forEach(function (dataset, i) {
							var meta = chartInstance.controller.getDatasetMeta(i)
							Chart.helpers.each(
								meta.data.forEach(function (bar, index) {
									data = dataset.data[index]
									if (i == 0) {
										ctx.fillText(data, 50, bar._model.y + 4)
									} else {
										ctx.fillText(data, bar._model.x - 25, bar._model.y + 4)
									}
								}),
								this
							)
						}),
						this
					)

					// draw total count
					this.data.datasets[0].data.forEach(function (data, index) {
						var total = data + this.data.datasets[1].data[index]
						var meta = chartInstance.controller.getDatasetMeta(1)
						var posX = meta.data[index]._model.x
						var posY = meta.data[index]._model.y

						ctx.fillStyle = "black"
						ctx.fillText(total, posX + 4, posY + 4)
					}, this)
				},
			}, */
		}
		return (
			<div id="chart">
				<Bar data={chartData} options={opts} /* plugins={[totalizer]} */ />
			</div>
		)
	}

	homeSalesChartOld = () => {
		let d = this.buildHomeSalesData()
		if (!d || d.years.length == 0) {
			return ""
		}
		// Build data
		let labels = []
		let sets = []
		let i = 0
		_.forEach(d.store, (yearRow, year) => {
			let set = {
				label: year,
				backgroundColor: colorArray[i],
				borderColor: colorArray[i],
				borderWidth: 1,
				data: [],
			}
			_.forEach(yearRow, (typeRow, type) => {
				// Label logic
				if (year == d.years[0]) {
					_.forEach(typeRow, (v, builderName) => {
						labels.push(`${type} - ${builderName}`)
					})
					//labels.push(`${type} Total`)
					//labels.push("")
				}
				// Count is the total for this combo
				let count = 0
				_.forEach(typeRow, (v, builderName) => {
					set.data.push(v)
					count += v
				})
				count = parseFloat(count.toFixed(2))
				//set.data.push(count)
				//set.data.push("")
			})
			sets.push(set)
			i++
		})
		//console.log(labels, sets)
		let sorted = helpers.orderByLotType(labels, sets[0].data)
		sets[0].data = sorted.data
		let data = {
			labels: sorted.labels,
			datasets: sets,
		}
		const opts = {
			legend: {
				display: true,
				position: "bottom",
			},
			plugins: {
				datalabels: { display: false },
			},
		}
		return (
			<>
				<Bar data={data} options={opts} />
			</>
		)
	}

	homeSalesTable() {
		let store = this.buildHomeSalesData()
		let data = []
		_.forEach(store.store, (yearRow, year) => {
			_.forEach(yearRow, (typeRow, type) => {
				_.forEach(typeRow, (v, builderName) => {
					data.push({
						year,
						lot_type: type,
						net: v,
						builder: builderName,
					})
				})
			})
		})
		return data
	}

	summary() {
		// The realtor percents here would be calculated on an actual basis
		let store = {}
		let ret = []
		let model = {
			gross: 0,
			cancels: 0,
			net: 0,
			starts: 0,
			closings: 0,
			net_realtor: 0,
			net_builder: 0,
		}
		_.forEach(this.props.payload.sales.current, (v) => {
			if (v.transfer_date) return
			let builder = _.find(this.props.payload.public.builders, { id: v.builder })
			let type = _.find(this.props.payload.public.lot_types, { id: v.lot_type })
			if (builder && type) {
				let path = `${helpers.safeBuilderName(builder.name)}.${type.name}`
				if (!_.has(store, path)) {
					_.setWith(store, path, _.clone(model), Object)
				}
				store[helpers.safeBuilderName(builder.name)][type.name].gross++
				store[helpers.safeBuilderName(builder.name)][type.name].net++
				if (!v.bustout_date) {
					if (v.realtor_involved === 1) {
						store[helpers.safeBuilderName(builder.name)][type.name].net_realtor++
					} else {
						store[helpers.safeBuilderName(builder.name)][type.name].net_builder++
					}
				}
			}
		})
		_.forEach(this.props.payload.bustouts.current, (v) => {
			if (v.transfer_date) return
			let builder = _.find(this.props.payload.public.builders, { id: v.builder })
			let type = _.find(this.props.payload.public.lot_types, { id: v.lot_type })
			if (builder && type) {
				let path = `${helpers.safeBuilderName(builder.name)}.${type.name}`
				if (!_.has(store, path)) {
					_.setWith(store, path, _.clone(model), Object)
				}
				store[helpers.safeBuilderName(builder.name)][type.name].cancels++
				store[helpers.safeBuilderName(builder.name)][type.name].net--
			}
		})
		_.forEach(this.props.payload.closings.current, (v) => {
			if (v.transfer_date) return
			let builder = _.find(this.props.payload.public.builders, { id: v.builder })
			let type = _.find(this.props.payload.public.lot_types, { id: v.lot_type })
			if (builder && type) {
				let path = `${helpers.safeBuilderName(builder.name)}.${type.name}`
				if (!_.has(store, path)) {
					_.setWith(store, path, _.clone(model), Object)
				}
				store[helpers.safeBuilderName(builder.name)][type.name].closings++
			}
		})
		// Calc starts
		_.forEach(this.props.payload.exec.lots, (v) => {
			if (
				v.start_date >= this.props.currentDates.startStamp &&
				v.start_date <= this.props.currentDates.endStamp
			) {
				let builder = _.find(this.props.payload.public.builders, { id: v.builder })
				let type = _.find(this.props.payload.public.lot_types, { id: v.lot_type })
				if (builder && type) {
					let path = `${helpers.safeBuilderName(builder.name)}.${type.name}`
					if (!_.has(store, path)) {
						_.setWith(store, path, _.clone(model), Object)
					}
					store[helpers.safeBuilderName(builder.name)][type.name].starts++
				}
			}
		})

		// Build the table
		_.forEach(store, (v1, builderName) => {
			_.forEach(v1, (v2, lotType) => {
				// calculate realtor percents
				let realtorPercent = 0
				if (v2.net && v2.net_realtor) {
					v2.net_realtor_percent = Math.round((v2.net_realtor / v2.net) * 100)
				}
				if (v2.net && v2.net_builder) {
					v2.net_builder_percent = Math.round((v2.net_builder / v2.net) * 100)
				}
				let net_realtor = `${v2.net_realtor} ${v2.net_realtor_percent ? ` / ${v2.net_realtor_percent}%` : ""}`
				let net_builder = `${v2.net_builder} ${v2.net_builder_percent ? ` / ${v2.net_builder_percent}%` : ""}`
				ret.push({
					builder: builderName,
					lot_type: lotType,
					gross: v2.gross,
					cancels: v2.cancels,
					net: v2.net,
					starts: v2.starts,
					closings: v2.closings,
					net_realtor,
					net_builder,
				})
			})
		})

		return ret
	}

	builderSummary() {
		// The realtor percents here would be calculated on an actual basis
		let store = {}
		let ret = []
		let model = {
			gross: 0,
			cancels: 0,
			net: 0,
			traffic: 0,
			starts: 0,
			closings: 0,
			net_realtor: 0,
			net_builder: 0,
		}
		_.forEach(this.props.payload.sales.current, (v) => {
			if (v.transfer_date) return
			let builder = _.find(this.props.payload.public.builders, { id: v.builder })
			if (builder) {
				let path = `${helpers.safeBuilderName(builder.name)}`
				if (!_.has(store, path)) {
					_.setWith(store, path, _.clone(model), Object)
				}
				store[helpers.safeBuilderName(builder.name)].gross++
				store[helpers.safeBuilderName(builder.name)].net++
				if (!v.bustout_date) {
					if (v.realtor_involved === 1) {
						store[helpers.safeBuilderName(builder.name)].net_realtor++
					} else {
						store[helpers.safeBuilderName(builder.name)].net_builder++
					}
				}
			}
		})
		_.forEach(this.props.payload.bustouts.current, (v) => {
			if (v.transfer_date) return
			let builder = _.find(this.props.payload.public.builders, { id: v.builder })
			if (builder) {
				let path = `${helpers.safeBuilderName(builder.name)}`
				if (!_.has(store, path)) {
					_.setWith(store, path, _.clone(model), Object)
				}
				store[helpers.safeBuilderName(builder.name)].cancels++
				store[helpers.safeBuilderName(builder.name)].net--
			}
		})
		_.forEach(this.props.payload.closings.current, (v) => {
			if (v.transfer_date) return
			let builder = _.find(this.props.payload.public.builders, { id: v.builder })
			if (builder) {
				let path = `${helpers.safeBuilderName(builder.name)}`
				if (!_.has(store, path)) {
					_.setWith(store, path, _.clone(model), Object)
				}
				store[helpers.safeBuilderName(builder.name)].closings++
			}
		})
		// Calc starts
		_.forEach(this.props.payload.exec.lots, (v) => {
			if (
				v.start_date >= this.props.currentDates.startStamp &&
				v.start_date <= this.props.currentDates.endStamp
			) {
				let builder = _.find(this.props.payload.public.builders, { id: v.builder })
				if (builder) {
					let path = `${helpers.safeBuilderName(builder.name)}`
					if (!_.has(store, path)) {
						_.setWith(store, path, _.clone(model), Object)
					}
					store[helpers.safeBuilderName(builder.name)].starts++
				}
			}
		})

		_.forEach(this.props.payload.traffic.current.entries, (v) => {
			let builder = _.find(this.props.payload.public.builders, { id: v.builder })
			if (builder) {
				let path = `${helpers.safeBuilderName(builder.name)}`
				if (!_.has(store, path)) {
					_.setWith(store, path, _.clone(model), Object)
				}
				store[helpers.safeBuilderName(builder.name)].traffic++
			}
		})
		_.forEach(this.props.payload.traffic.current.grouped.array, (v) => {
			let builder = _.find(this.props.payload.public.builders, { id: v.builder })
			if (builder) {
				let path = `${helpers.safeBuilderName(builder.name)}`
				if (!_.has(store, path)) {
					_.setWith(store, path, _.clone(model), Object)
				}
				if (v.prospect_count) {
					store[helpers.safeBuilderName(builder.name)].traffic += v.prospect_count
				}
				if (v.realtor_count) {
					store[helpers.safeBuilderName(builder.name)].traffic += v.realtor_count
				}
			}
		})

		// Build the table
		_.forEach(store, (v1, builderName) => {
			// calculate realtor percents
			let realtorPercent = 0
			if (v1.net && v1.net_realtor) {
				v1.net_realtor_percent = Math.round((v1.net_realtor / v1.net) * 100)
			}
			if (v1.net && v1.net_builder) {
				v1.net_builder_percent = Math.round((v1.net_builder / v1.net) * 100)
			}
			let net_realtor = `${v1.net_realtor} ${v1.net_realtor_percent ? ` / ${v1.net_realtor_percent}%` : ""}`
			let net_builder = `${v1.net_builder} ${v1.net_builder_percent ? ` / ${v1.net_builder_percent}%` : ""}`
			ret.push({
				builder: builderName,
				traffic: v1.traffic,
				gross: v1.gross,
				cancels: v1.cancels,
				net: v1.net,
				starts: v1.starts,
				closings: v1.closings,
				net_realtor,
				net_builder,
			})
		})

		return ret
	}

	render() {
		if (!this.props.payloadStatus || this.props.activeProperties.length == 0) {
			return (
				<div className="lotStatus__pleaseChoose">
					<h1>Please choose one community to view reporting.</h1>
				</div>
			)
		} else {
			return (
				<div className="sales">
					<div className="imageGroup">
						<Title title="Builder Sales Summary - Net" />
						<div className="content">
							<h3>By Lot Type + Builder + Section</h3>
							<p className="mid">
								To view Average Home and Lot Price data by the overall Lot Type, or Average Home and Lot
								Price data by Lot Type/Builder, go to Sales/Averages/Home and Lot Price widgets.
								<br />
								To view Overall Community Average Sale Price, Sq. Ft. and PPSF, go to Sales Overview.
							</p>
							<div className="twoCol">
								<div className="switch" onClick={(e) => e.stopPropagation()}>
									<Switch
										onChange={() => this.generateTable(true)}
										checked={this.state.closed}
										checkedIcon={false}
										uncheckedIcon={false}
										key={"builderSalesSummarySwitch"}
										id={"builderSalesSummarySwitch"}
									/>
									<p>Showing {this.state.showing}</p>
								</div>
							</div>
							<FullTable
								data={this.state.data}
								columns={this.columns()}
								name="salesSummary__ltbs"
								title="Sales Summary"
								classNames="small"
								reInit={true}
							/>
						</div>
						<div className="content">
							<h3>By Lot Type + Builder</h3>
							<ImageExport name="LotTypeBuilder" block={true} />
							<FullTable
								data={this.state.dataSans}
								columns={this.columnsSans()}
								name="salesSummary__ltb"
								title="Sales SummaryWithoutSection"
								classNames="small"
								reInit={true}
							/>
						</div>
					</div>
					<div className="imageGroup">
						<div className="content" style={{ paddingTop: 25 }}>
							<div>
								<ImageExport name="HomeSalesLotTypeBuilder" />
								<div>
									<h3>Home Sales - Lot Type &amp; Builder - Net</h3>
									<Switch
										onChange={() => {
											this.setState({ showToday: !this.state.showToday })
										}}
										checked={this.state.showToday}
										checkedIcon={false}
										uncheckedIcon={false}
										key={"switch"}
										id={"switch"}
									/>
								</div>
								{this.homeSalesChart()}
							</div>
							<div>
								<FullTable
									data={this.homeSalesTable()}
									columns={this.state.homeSalesColumns}
									name="salesSummary__ltbnet"
									classNames="small"
									title="Sales Summary Lot Type + Builder"
								/>
							</div>
						</div>
					</div>
					<div className="imageGroup">
						<div className="content" style={{ paddingTop: 25 }}>
							<h3>Sales Summary</h3>
							<div>
								<FullTable
									data={this.summary()}
									columns={this.state.summaryColumns}
									name="salesSummary__summary"
									classNames="small"
									title="Summary"
								/>
							</div>
							<h3>Builder Summary</h3>
							<div>
								<FullTable
									data={this.builderSummary()}
									columns={this.state.builderSummaryColumns}
									name="salesSummary__builderSummary"
									classNames="small"
									title="BuilderSummary"
								/>
							</div>
							<FloorplanAnalysis {...this.props} />
						</div>
					</div>
				</div>
			)
		}
	}
}

function mapStateToProps(state) {
	return {
		currentDates: state.currentDates,
		compareDates: state.compareDates,
		payload: state.payload,
		payloadStatus: state.payloadStatus,
		activeProperties: state.activeProperties,
	}
}

function matchDispatchToProps(dispatch) {
	return bindActionCreators({}, dispatch)
}

export default connect(mapStateToProps, matchDispatchToProps)(BuilderSalesSummary)
